import React from 'react'
import SellableCardCarouselWithTitle from '#src/components/SellableCardCarouselWithTitle'
import { RecommendedListFragment, DepartmentType } from '#src/generated/graphql'
import styles from './styles.css'

interface RecommendedListProps {
  list: RecommendedListFragment
  department: DepartmentType
  aspectRatio?: 'tall' | 'wide'
}

const RecommendedList: React.SFC<RecommendedListProps> = ({ list, department, aspectRatio }) => {
  if (list.sellables.length === 0) {
    return null
  }

  return (
    <SellableCardCarouselWithTitle
      title={list.displayName}
      department={department}
      subTitle={list.subTitle}
      aspectRatio={aspectRatio}
      sellables={list.sellables || null}
      className={styles.recommendedList}
      infinite={false}
    />
  )
}

export default RecommendedList
